module.exports = __webpack_public_path__ + "static/pioneers-announce-4fd18382b7d051bc292bff10c19d5dc5.jpg";